<p-panel>
    <span class="d-flex justify-content-between align-items-center">
        <h4>Datos del Tratamiento</h4>
        <div class="d-flex align-items-end">
            <button class="btn btn-primary" (click)="router.navigate(['dashboard','crear-producto-fitosanitario'])">Crear Producto Fitosanitario</button>
        </div>
    </span>

    <div class="container-fluid">
        <div class="d-flex gap-3 justify-content-between mb-4" [class.flex-column]="navigationService.isMobile()">
            <div class="col-sm-12 col-md-6">
                <app-form-builder [fields]="form.formFields" [model]="model" [distributionColumns]="1"
                    [undoEnabled]="false">
                </app-form-builder>
            </div>
            <div class="col-sm-12 col-md-6">
                <app-form-builder [fields]="form.formFieldsCheck" [model]="model" [distributionColumns]="2"
                    [undoEnabled]="false">
                </app-form-builder>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h4>Añadir Productos</h4>
                <p class="small font-weight-bold">
                    <b style="color: red;">*</b>: La unidad de medida es obligatoria si ha seleccionado un producto.
                </p>
            </div>
        </div>

        <!-- // TODO: Rehacer el formulario de añadir productos para que sea responsive -->

        <div class="row">
            <div class="col">
                <b>Productos añadidos </b> {{ form.productRows().length }} de 7
            </div>
            <div class="col">
                <button class="btn btn-success float-end" (click)="addProductRow(); " [disabled]="form.productRows.length > 6">Agregar al listado</button>
            </div>
        </div>


        <div #containerProducts  [class.style-mobile]="navigationService.isMobile()">
            @for (item of form.productRows(); track $index) {
                <div class="w-full row mb-4 align-items-end g-2" [ngClass]="!navigationService.isMobile() ? 'flex-nowrap' : ''">
                    <div class="col-auto d-flex align-items-center">
                        <b>{{ $index + 1 }}</b>
                    </div>

                    <div class="col-md-2 col-xl-3 d-flex flex-column">
                        <label [for]="'producto-'+ $index"> Producto </label>
                        <p-select [id]="'producto-'+ $index" [(ngModel)]="item.productos.selected" [options]="item.productos.filtered" optionLabel="label"
                            filterBY="label" optionValue="value" [filter]="true" [showClear]="true" [ngStyle]="{'max-width': '100%'}" 
                            (onChange)="applyFilters('productos',$index)">
                        </p-select>
                    </div>
    
                    <div class="col d-flex flex-column">
                        <label [for]="'uso-'+ $index"> Uso </label>
                        <p-select [id]="'uso-'+ $index" [(ngModel)]="item.usos.selected" [options]="item.usos.filtered" optionLabel="label" (onChange)="applyFilters('usos', $index)"
                            filterBY="label" optionValue="value" [filter]="true" [showClear]="true" [ngStyle]="{'max-width': '100%'}"></p-select>
                    </div>
    
                    <div class="col col-md-2 col-xl-3 d-flex flex-column">
                        <label [for]="'agente-'+ $index"> Agente </label>
                        <p-select [id]="'agente-'+ $index" [(ngModel)]="item.agentes.selected" [options]="item.agentes.filtered" optionLabel="label"
                            filterBY="label" optionValue="value" [filter]="true" [showClear]="true" (onChange)="applyFilters('agentes', $index)"
                            [ngStyle]="{'max-width': '100%'}"></p-select>
                    </div>
    
                    <div class="col-md-1 col-sm-6">
                        <label [for]="'cuaderno-'+ $index" *ngIf="!enableLegalMode"> Cuaderno </label>
                        <label [for]="'dosis-'+ $index"> Dosis </label>
                        {{ !showUnidadesMedidaSIEX ? ("(" + getMesureValue(item, 'uds_medida') + "/Ha)") : ''}}
                         <input [class.invalid]="form.values.status[$index] === 'invalid'"
                                [class.valid]="form.values.status[$index] === 'valid'"
                                (keyup)="checkDosis($index)" [(ngModel)]="form.values.cantidadCuaderno[$index]" type="number"
                                placeholder="..." pInputText />
                    </div>
    
                    <div class="col d-flex flex-column" *ngIf="showUnidadesMedidaSIEX">
                        <label>Ud Medida Dosis</label>
                        <p-select
                            [options]="item.ud_medida_dosis_select?.values"
                            [(ngModel)]="item.ud_medida_dosis"
                            optionLabel="label"
                            optionValue="label"
                            [filter]="true"
                            [showClear]="true"
                        ></p-select>
                    </div>

                    <div class="col d-flex justify-content-between align-items-center gap-2">
                        <div class="d-flex flex-column justify-content-center align-content-center">
                            <label for=""> &nbsp; </label>
                            <button class="btn btn-sm btn-danger" (click)="removeProductRow($index)"> <i class="fa fa-trash"></i> </button>
                        </div>
                        <div class="d-flex flex-column justify-content-center align-content-center" *ngIf="item.agentes.selected">
                            <label for="">Info.</label>
                            <button class="btn btn-sm btn-info" (click)="openDialog = true; showProducto = $index"> <i
                                        class="fa fa-info"></i> </button>
                        </div>
                    </div>
                </div>
    
                <div class="row mb-4">
                    <div class="col-12 d-flex justify-content-center align-content-center gap-2"  *ngIf="item.agentes?.selected && item.usos.selected?.label !== '-' && appName !== 'agroleza'">
                        <span style="position: relative; top: 5px">
                                Dosis. {{decimalFormat(item.agentes.selected?.dosis_min, 2, '.', ',', 3)}}
                                <span *ngIf="item.agentes.selected?.dosis_max && item.agentes.selected?.dosis_max !== 0">
                                    - {{decimalFormat(item.agentes.selected?.dosis_max || 0, 2, '.', ',', 3)}}
                                </span>
                                {{item.agentes.selected?.unidad_medida}}
                        </span>
    
                        <span style="position: relative; top: 5px">Plazo Seg.
                                {{item.agentes.selected?.plazo_seguridad}}</span>
                    </div>
                </div>
    
            }
        </div>


        <!-- <div class="container-fluid">
            <div class="row no-gutters">
                @for(row of form.productRows ; track i; let i = $index) {
                <div class="row mt-4">
                    <b class="col-1 text-center">{{i + 1}}._ &nbsp;</b>
                    <div class="col-sm-4 col-xs-">
                        <p *ngIf="i === 0">Producto</p>
                        <p-select [(ngModel)]="row.productos.selected" (onChange)="applyFilters('productos', i)"
                            [options]="row.productos.filtered" optionLabel="label" filterBY="label" optionValue="value"
                            [filter]="true" [showClear]="true" class="w-100"></p-select>
                    </div>
                    <div class="col-sm-4 col-xs-12">
                        <p *ngIf="i === 0">Uso</p>
                        <p-select [(ngModel)]="row.usos.selected" (onChange)="applyFilters('usos', i)"
                            [options]="row.usos.filtered" [filter]="true" optionLabel="label" filterBY="label"
                            optionValue="value" class="w-100"></p-select>
                    </div>
                    <div class="col-sm-4 col-xs-12">
                        <p *ngIf="i === 0">Agente</p>
                        <p-select [(ngModel)]="row.agentes.selected" (onChange)="applyFilters('agentes', i)"
                            [filter]="row.agentes.filtered.length > 20" emptyFilterMessage="No hay resultados"
                            [options]="row.agentes.filtered" [filter]="true" optionLabel="label" filterBY="label"
                            optionValue="value" class="w-100"></p-select>
                    </div>
                    <div class="col-lg-1 col-sm-6 col-xs-6">
                        <p *ngIf="i === 0">
                            <span *ngIf="!enableLegalMode">Cuaderno</span>
                            <span *ngIf="enableLegalMode">Dosis</span>
                        </p>
                        <input [class.invalid]="form.values.status[i] === 'invalid'"
                            [class.valid]="form.values.status[i] === 'valid'" style="width: 100px !important"
                            (keyup)="checkDosis(i)" [(ngModel)]="form.values.cantidadCuaderno[i]" type="number"
                            placeholder="..." pInputText />
                    </div>
                    <div class="col-lg-1 col-sm-6 col-xs-6" *ngIf="!hiddeDosisAplicada">
                        <p *ngIf="i === 0">
                            <span *ngIf="!enableLegalMode">Aplicada</span>
                            <span *ngIf="enableLegalMode">Cant.&nbsp;2</span>
                        </p>
                        <input [(ngModel)]="form.values.cantidadReal[i]" style="width: 100px !important" type="number"
                            placeholder="..." pInputText />
                    </div>
                    <div class="col-lg-1 col-sm-6 col-xs-6">
                        <p *ngIf="i === 0">
                            <span *ngIf="!enableLegalMode">Ud.&nbsp;Aplicada<b style="color: red;">*</b></span>
                            <span *ngIf="enableLegalMode">Ud.&nbsp;Medida<b style="color: red;">*</b></span>
                        </p>
                        <p>
                            {{ getMesureValue(form.productRows[i], 'uds_medida') }}
                            <span *ngIf="getMesureValue(form.productRows[i], 'uds_medida')">/Ha</span>
                        </p>
                    </div>
                    <div class="col-lg-1 col-sm-6 col-xs-6 text-center" *ngIf="row.agentes.selected">
                        <p *ngIf="i === 0">Info. Producto</p>
                        <button class="btn btn-info" (click)="openDialog = true; showProducto = i"> <i
                                class="fa fa-info"></i> </button>
                    </div>
                    <div *ngIf="showTratamientosRecetaSwitch" class="col" style="flex: 1">
                        <p *ngIf="i === 0">
                            Oculto
                        </p>
                        <p-toggleSwitch [(ngModel)]="row.ocultar_en_receta"
                            [disabled]="!form.productRows[i]?.productos?.selected">
                        </p-toggleSwitch>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <div class="mr-10" *ngIf="row.agentes?.selected && row.usos.selected?.label !== '-'">
                        <table *ngIf="appName === 'agroleza'" class="table-style">
                            <tr>
                                <th>Plazo Seguridad</th>
                                <th>Volumen Máximo de Caldo</th>
                                <th>Nº Máx. de Aplicaciones</th>
                                <th>Dosis</th>
                                <th>Intervalos</th>
                            </tr>
                            <tr>
                                <td>{{row.agentes.selected?.plazo_seguridad}}</td>
                                <td>{{row.agentes.selected?.vol_caldo}}</td>
                                <td>{{row.agentes.selected?.n_aplicaciones}}</td>
                                <td>
                                    <span style="position: relative;top: 5px">
                                        {{decimalFormat(row.agentes.selected?.dosis_min, 2, '.', ',', 3)}}
                                        <span
                                            *ngIf="row.agentes.selected?.dosis_max && row.agentes.selected?.dosis_max !== 0">
                                            - {{decimalFormat(row.agentes.selected?.dosis_max, 2, '.', ',', 3)}}
                                        </span>
                                        {{row.agentes.selected?.unidad_medida}}
                                    </span>
                                </td>
                                <td>{{row.agentes.selected?.intervalos}}</td>
                            </tr>
                        </table>
                        <span *ngIf="appName !== 'agroleza'" style="position: relative; top: 5px">
                            Dosis. {{decimalFormat(row.agentes.selected?.dosis_min, 2, '.', ',', 3)}}
                            <span *ngIf="row.agentes.selected?.dosis_max && row.agentes.selected?.dosis_max !== 0">
                                - {{decimalFormat(row.agentes.selected?.dosis_max || 0, 2, '.', ',', 3)}}
                            </span>
                            {{row.agentes.selected?.unidad_medida}}
                        </span>
                    </div>
                    &nbsp; &nbsp;
                    <div style="margin-right: 10px;"
                        *ngIf="row.agentes.selected && row.usos.selected?.label !== '-' && appName!=='agroleza'">
                        <span style="position: relative; top: 5px">Plazo Seg.
                            {{row.agentes.selected.plazo_seguridad}}</span>
                    </div>
                </div>
                }
            </div>
        </div> -->
    </div>


    <div class="container d-flex justify-content-center mt-4">
        <button class="btn btn-dark mx-2" (click)="goBack()">Volver</button>
        <app-request-button [request]="request" [mode]="requestButtonType" [lockOnSuccess]="true" (click)="submit()">
        </app-request-button>
    </div>

</p-panel>

<p-dialog [(visible)]="openDialog" [modal]="true" [style]="{'max-width': '100vw', 'width': '80vw'}">

    <ng-template #header>
        <h3>Información Producto {{form.productRows()[showProducto]?.productos?.selected?.nombre}}</h3>
    </ng-template>

    <table class="table table-striped table-bordered">
        <thead>
            <tr>
                <th>Producto</th>
                <th>Uso</th>
                <th>Agente</th>
                <th>Dosis Mínima</th>
                <th>Dosis Máxima</th>
                <th>Dosis&nbsp;Aplicada</th>
                <th>Ud.&nbsp;Medida</th>
                <th>Vol.&nbsp;Caldo</th>
                <th>Condiciones de uso</th>
                <th>Forma y Época</th>
                <th>Número máximo de aplicaciones</th>
                <th>Intervalos</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>{{form.productRows()[showProducto]?.productos?.selected?.nombre}}</td>
                <td>{{form.productRows()[showProducto]?.usos?.selected?.uso}}</td>
                <td>{{form.productRows()[showProducto]?.agentes?.selected?.agente}}</td>
                <td>
                    {{
                        decimalFormat(form.productRows()[showProducto]?.agentes?.selected?.dosis_min, 2, '', ',') + '\n' +
                        form.productRows()[showProducto]?.agentes?.selected?.unidad_medida
                    }}
                </td>
                <td>
                    {{
                        decimalFormat(form.productRows()[showProducto]?.agentes?.selected?.dosis_max, 2, '', ',') + '\n' +
                        form.productRows()[showProducto]?.agentes?.selected?.unidad_medida
                    }} 
                </td>
                <td>{{decimalFormat(+(form.values.cantidadCuaderno[showProducto] ?? 0), 2, '', ',')}}</td>
                <!-- <td>{{form.productRows()[showProducto]?.uds_medida}}</td> -->
                <td>{{form.productRows()[showProducto]?.usos?.selected?.vol_caldo}}</td>
                <td>{{form.productRows()[showProducto]?.productos?.selected?.producto?.condiciones_uso}}</td>
                <td>{{form.productRows()[showProducto]?.usos?.selected?.forma_epoca}}</td>
                <td>{{form.productRows()[showProducto]?.agentes?.selected?.n_aplicaciones}}</td>
                <td>{{form.productRows()[showProducto]?.agentes?.selected?.intervalos}}</td>
            </tr>
    </table>

    <ng-template #footer>
        <div class="container-fluid text-center w-100">
            <p-button class="m-auto" type="button" label="Cerrar" (click)="openDialog = false"></p-button>
        </div>
    </ng-template>


</p-dialog>